import { Link } from 'react-router-dom';

const commodities = [
  {
    label: 'Energy Commodities',
    icon: 'ri-gas-station-line',
    description: 'Crude oil, refined petroleum products, LPG and natural gas across global markets.',
    slug: 'energy-commodities',
  },
  {
    label: 'Energy Transition Metals',
    icon: 'ri-flashlight-line',
    description: 'Lithium, cobalt, nickel and other critical metals powering the clean energy shift.',
    slug: 'energy-transition-metals',
  },
  {
    label: 'Soft Commodities',
    icon: 'ri-seedling-line',
    description: 'Agricultural products and biofuel feedstocks supporting energy diversification.',
    slug: 'soft-commodities',
  },
  {
    label: 'Non-Ferrous Metals',
    icon: 'ri-copper-diamond-line',
    description: 'Aluminium, copper and zinc traded in physical and forward markets worldwide.',
    slug: 'non-ferrous-metals',
  },
  {
    label: 'Recycled Metals',
    icon: 'ri-recycle-line',
    description: 'Scrap and secondary metals supporting circular economy supply chains.',
    slug: 'recycled-metals',
  },
  {
    label: 'Ferrous Metals',
    icon: 'ri-hammer-line',
    description: 'Iron ore, steel scrap and pig iron for industrial and construction markets.',
    slug: 'ferrous-metals',
  },
];

export default function TradingProductsSection() {
  return (
    <section id="products" className="bg-[#071525] py-24 relative overflow-hidden">
      {/* Decorative background texture */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              'repeating-linear-gradient(0deg, transparent, transparent 60px, rgba(212,87,26,0.4) 60px, rgba(212,87,26,0.4) 61px), repeating-linear-gradient(90deg, transparent, transparent 60px, rgba(212,87,26,0.4) 60px, rgba(212,87,26,0.4) 61px)',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        {/* Header */}
        <div className="mb-14">
          <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-3">
            What We Trade
          </p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <h2 className="text-white text-3xl lg:text-4xl font-bold leading-tight max-w-xl">
              A Diverse Portfolio of<br />Global Commodities
            </h2>
            <p className="text-white/45 text-sm leading-relaxed max-w-sm">
              From conventional energy to critical minerals, NRG Trading operates across a broad
              spectrum of physical commodity markets to meet the world&rsquo;s evolving energy needs.
            </p>
          </div>
        </div>

        {/* Grid — first 3 full cards, last 3 in a row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/8 rounded-xl overflow-hidden border border-white/10">
          {commodities.slice(0, 3).map((item) => (
            <Link
              key={item.label}
              to={`/products/${item.slug}`}
              className="group bg-[#071525] hover:bg-[#0c1f38] transition-colors duration-300 p-8 flex flex-col gap-5 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white/5 group-hover:bg-[#d4571a]/15 transition-colors duration-300">
                <i className={`${item.icon} text-[#d4571a] text-2xl`} />
              </div>
              <div>
                <h3 className="text-white text-base font-semibold mb-2 leading-snug">
                  {item.label}
                </h3>
                <p className="text-white/40 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/8 rounded-xl overflow-hidden border border-white/10 mt-px">
          {commodities.slice(3).map((item) => (
            <Link
              key={item.label}
              to={`/products/${item.slug}`}
              className="group bg-[#071525] hover:bg-[#0c1f38] transition-colors duration-300 p-8 flex flex-col gap-5 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white/5 group-hover:bg-[#d4571a]/15 transition-colors duration-300">
                <i className={`${item.icon} text-[#d4571a] text-2xl`} />
              </div>
              <div>
                <h3 className="text-white text-base font-semibold mb-2 leading-snug">
                  {item.label}
                </h3>
                <p className="text-white/40 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
